<script>



   
    let showInstallMessage = false;

    // Detects if device is on iOS 
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
    }
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      showInstallMessage = true;
    }


    function closePopup() {
        showInstallMessage = false;
    }
</script>

<style>
    .frame {
        display: block;
        background: #00627D;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
        z-index: 111111111;
        color: #000;
        text-align: center;
    }

    article {
      
       max-width: 600px;
        margin: auto;
        width: 90%;
        background: #fff;
       
        box-shadow: 5px 5px 15px rgba(0,0,0,.25);
    }

    .info figure,
    .info div {
         padding:1em;
    }

    .info figure {
        padding-bottom: 0em;
    }

    small {
         width: 90%;
         max-width: 600px;
        display: block;
        color:#fff;
        text-align: right;
        margin: auto;
    }

    footer {
        background: #eee;
        padding: .5em;
        text-align: center;
    }

    img {
        margin: 0 .5em;
    }
    span {
        font-weight: bold;
    }

    .logo {
        border-radius: 5px;
        margin: 0;
        display: block;
        margin: auto;
    }
</style>

{#if showInstallMessage}
<div class="frame">
    <div> 
         <small  on:click={closePopup}>Dismiss and continue x</small>
         <article>
     
       
            <div class="info">
                <figure>
                    <img class="logo" width="90" src="/logo-512.png" alt="PWA Icon" />
                </figure>
                <div>
                    <h2>Install co-operative membership</h2>
                    <p>Install this application on your home screen for quick and easy access when you're on the go</p>
                </div>
                <footer>
                    <div>Just tap <img src="/svg/light.svg" height="10" alt="Share iOS"> then <span>'Add To Home Screen'</span></div>
                </footer>
            </div>


        </article>
    </div>
    
</div>
{/if}
